export const importAndSaveAddressTransformer = (data: any) => {
  const { response } = data;
  if (data.status == 'success' && response.status == 'success') {
    return {
      success: true,
      title: response.title,
      addressId: response.address_id
    };
  } else {
    return {
      success: false,
      ...response,
    };
  }
};